import {
  type StatsigOptions,
  type StatsigUser,
  useStatsigInternalClientFactoryAsync,
} from '@statsig/react-bindings'

import { StatsigClientRN } from './StatsigClientRN'

// Vendored from @statsig/react-native-bindings. Creates an RN client and runs
// `initializeAsync` (network fetch); `isLoading` flips false when ready.
export function useClientAsyncInitRN(
  sdkKey: string,
  initialUser: StatsigUser,
  statsigOptions: StatsigOptions | null = null,
): { isLoading: boolean; client: StatsigClientRN } {
  return useStatsigInternalClientFactoryAsync(
    (args) =>
      new StatsigClientRN(args.sdkKey, args.initialUser, args.statsigOptions),
    {
      sdkKey,
      initialUser,
      statsigOptions,
    },
  )
}
